import { useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { StandardPanel } from '../../../_components/panel/standard.panel';
import { FileTypeEnum } from "../../../_common/enum";
import { TicketFileDrawer } from "./ticket-fileDrawer";
import { TicketFileList } from "./ticket-fileList";

export function TicketFilePanel() {

    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const [refreshCounter, setRefreshCounter] = useState(0);
    return (
        <>
            <StandardPanel
                title="Files"
                buttons={[
                    { icon: "upload", onClick: () => { navigate("ManageFiles/Create") } },
                ]}
                loading={isLoading}>

                <TicketFileList fileType={FileTypeEnum.Ticket} refreshCounter={refreshCounter} />
            </StandardPanel>
            <Routes>
                <Route path="Managefiles/*" element={<TicketFileDrawer fileType={FileTypeEnum.Ticket} onSave={() => { setRefreshCounter(r => (++r)); navigate(""); }} onClose={() => { navigate(""); }} />} />
            </Routes>

        </>
    );

}
